import PreviewSection from "./PreviewSection";
import { generateInterviewPreview } from "../utils/previewGenerators.jsx";

function InterviewPreview({ formData, currentStep }) {
  const preview = generateInterviewPreview(formData, currentStep);

  if (!preview) {
    return null;
  }

  return (
    <div className="email-preview">
      <h3><i className="fas fa-eye"></i> Email Preview</h3>
      <PreviewSection title={preview.title} noRibbon={currentStep === 1}>
        {preview.content}
      </PreviewSection>
    </div>
  );
}

export default InterviewPreview;
